import script from "./MovePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovePage.vue?vue&type=script&setup=true&lang=ts"

import "./MovePage.vue?vue&type=style&index=0&id=3642f819&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3642f819"]])

export default __exports__